/**
 * Cura — Product FAQ accordion
 * Click to open/close. Only one open at a time.
 * First item starts open (set in liquid via .is-open class).
 */
(function () {
  'use strict';

  function initFaq(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-faq-list]').forEach(function (list) {
      if (list.dataset.faqInit) return;
      list.dataset.faqInit = 'true';

      var items = Array.from(list.querySelectorAll('[data-faq-item]'));

      items.forEach(function (item) {
        var btn = item.querySelector('[data-faq-btn]');
        if (!btn) return;

        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          // Close all
          items.forEach(function (i) {
            i.classList.remove('is-open');
            var b = i.querySelector('[data-faq-btn]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });

          // Open clicked if it was closed
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFaq(document); });
  } else {
    initFaq(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initFaq(e.target); });
})();